import "./styles.scss";

import { NavLink } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { useApp } from "context/app";

import { ReactComponent as Logo } from "assets/icons/new/logo-text.svg";

const mainClass = "mobile-bar";

const MobileBar = ({ isStatic, onWebsiteClick }) => {
  const { user, current_website } = useApp();
  const { t } = useTranslation();

  const LogoTag = isStatic ? "div" : NavLink;

  return (
    <div className={mainClass}>
      <div className={`${mainClass}__logo`}>
        <LogoTag {...(isStatic ? {} : { to: "/", onClick: onWebsiteClick })}>
          <Logo />
        </LogoTag>
      </div>
      {user?.type === "client" && (
        <div className={`${mainClass}__website`}>
          <p>
            {t("Information for the website")}{" "}
            <NavLink
              onClick={onWebsiteClick}
              to={
                current_website?._id
                  ? `/websites/${current_website._id}`
                  : "/websites/new"
              }
            >
              <AnimatePresence initial={false} mode="wait">
                <motion.span
                  key={current_website?._id ?? "no-website"}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ type: "tween", duration: 0.2 }}
                >
                  {current_website?.website ?? t("Add website")}
                </motion.span>
              </AnimatePresence>
            </NavLink>
          </p>
        </div>
      )}
    </div>
  );
};

export default MobileBar;
